import React, {Suspense, useEffect} from 'react'
import {BrowserRouter, Route, Switch} from 'react-router-dom'
import CssBaseline from '@material-ui/core/CssBaseline'
import {ThemeProvider} from '@material-ui/core/styles'
import {shallowEqual} from 'react-redux'

import theme from 'theme'
import Root from 'containers/Root'
import NotifierProvider from 'components/Notifier'
import RootAuth from 'containers/RootAuth/RootAuth'
import CustomRouterUserConfirmation from 'components/CustomRouterUserConfirmation'
import {useAppSelector, useAppDispatch} from 'store/redux'
import {selectStations} from 'store/selectors'
import {PrivateRoute} from 'containers/RoleModel'
import Loader from 'pages/Loader'
import {getUserPermission} from 'store/actions/account'
import ProviderRedux from '../../store'
import 'modules/i18n'
import useStyles from './styles'
import {overlayRoutesList} from '../../modules/Routes/routeConfig'

function AppContent() {
  const {spp, wpp} = useAppSelector(selectStations, shallowEqual)
  const isLoadedPermission = useAppSelector(state => state.account.isLoadedPermission)
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(getUserPermission())
  }, [dispatch])

  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        {isLoadedPermission &&
          overlayRoutesList.map(
            route =>
              route.permission && <PrivateRoute key={route.path} plants={{spp, wpp}} {...route} />,
          )}
        <Route component={Root} />
      </Switch>
    </Suspense>
  )
}

function App() {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ProviderRedux>
          <NotifierProvider>
            <RootAuth>
              <BrowserRouter
                getUserConfirmation={(message, callback) =>
                  CustomRouterUserConfirmation(message, callback)
                }
              >
                <AppContent />
              </BrowserRouter>
            </RootAuth>
          </NotifierProvider>
        </ProviderRedux>
      </ThemeProvider>
    </div>
  )
}

export default App
